'use strict';/* global define:false */define('modules/core/modules/utils/services/iris',['angular'],function(ng){'use strict';/**
   * In Greek mythology, Iris (/ˈaɪrɨs/; Greek: Ἶρις)[1]
   * is the personification of the rainbow and messenger of the gods.
   * http://en.wikipedia.org/wiki/Iris_(mythology)
   *
   * A service to allow crazy communication pub-sub-ish style
   * want a parent scope to trigger something on child scopes and get the result?
   * iris is your best friend
   */// @ngInject
iris.$inject = ["$q"];
function iris($q){// jshint validthis:true
// jshint latedef:false
var binding={};this.bind=bind;this.unbind=unbind;this.trigger=trigger;/**
     * bind callback to given "channel"
     * @param  {String}   name channel name
     * @param  {Function} cb   callback that will return a promise
     * @return {Function}      function used to unbind the callback
     */function bind(name,cb){// no name = no fun
if(!name){return ng.noop;}// no cb as function = no fun
if(!ng.isFunction(cb)){return false;}// prepare the channel, if not present
if(!ng.isArray(binding[name])){binding[name]=[];}// add cb to the channel
binding[name].push(cb);// return "unbind"
return function(){unbind(name,cb);};}/**
     * unbind a callback from given "channel"
     * @param  {String}   name channel name
     * @param  {Function} cb   callback to be unregistered
     * @return {Boolean}
     */function unbind(name,cb){// no name = no fun
if(!name){return false;}// no channel = no fun
if(!binding[name]){return false;}// find the cb ...
var index=binding[name].indexOf(cb);// ... or fail
if(index<0){return false;}// remove the cb
binding[name].splice(index,1);return true;}/**
     * trigger the channel's callbacks
     * @param  {String} name channel name
     * @return {Promise}     $q.all promise
     */function trigger(name){// no name = no fun
if(!name){return false;}// map cbs into their results ...
var promises=binding[name].map(function(cb){return cb();});// ... and return
return $q.all(promises);}}return iris;});
